var map = {
	"./error.svg": 494,
	"./info.svg": 495,
	"./success.svg": 496,
	"./warning.svg": 497
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 692;


//////////////////
// WEBPACK FOOTER
// ./src/components/message/src/assets ^\.\/.*\.svg$
// module id = 692
// module chunks = 0